module.exports = __webpack_public_path__ + "static/media/mail.5be4975f.svg";